import React from 'react'
import { Grid } from '@material-ui/core'
import { Line } from 'react-chartjs-2'

import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'

import * as Utils from 'src/utils/chartsUtils'
import TableAAPP from '../../Tables/TableAAPP'
import TableMonthsCompanies from '../../Tables/TableMonthsCompanies'

const MEITotalElectricSalesCard = props => {
  const { tableTotalIndustry, tableTotalIndustryMonth, selectedDate, gBTotalIndustry, gATotalIndustry } = props
  return (
    <Card>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <div>
              <h3>Total industria por compañia</h3>
            </div>
            <br />
            <TableAAPP array={tableTotalIndustry} selectedDate={selectedDate} param="EMPRESA" colParam />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - años</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gATotalIndustry, 'EMPRESA', 'PORCENTAJE', 'y', '1')}
              options={Utils.optionsLine}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={6}>
            <h3>Participación del mercado - mes</h3>
            <br />
            <Line
              data={Utils.customBarLineDataGroup(gBTotalIndustry, 'EMPRESA', 'PORC', 'MES', '1')}
              options={Utils.optionsLine}
            />
          </Grid>
          <Grid item xs={12} sm={12} lg={12}>
            <TableMonthsCompanies
              array={tableTotalIndustryMonth}
              selectedDate={selectedDate}
              sizeHeader="1"
              param="EMPRESA"
              order="MES"
              title="MES"
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default MEITotalElectricSalesCard
